<ion-backdrop class="popup-backdrop" (click)="closePopup()"></ion-backdrop>

<div class="popup-card">
  <!-- Close icon -->
  <ion-icon name="close-outline" class="popup-close-icon" (click)="closePopup()"></ion-icon>

  <img *ngIf="illustration" [src]="illustration" alt="Illustration" class="popup-illustration" />

  <div class="popup-content">
    <p *ngIf="title" class="popup-title" [innerHTML]="title"></p>
    <p *ngIf="message" class="popup-message" [innerHTML]="message"></p>

    <div class="popup-actions">
      <ion-button color="primary" (click)="onPrimary()">
        {{ primaryLabel }}
      </ion-button>
      <ion-button fill="outline" color="primary" (click)="onSecondary()">
        {{ secondaryLabel }}
      </ion-button>
    </div>
  </div>
</div>